var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"btn",attrs:{"id":"FAST_FORWARD","name":"FAST_FORWARD","data-vcode":"FAST_FORWARD"}},[_c('img',{attrs:{"src":"/images/icons/forward.svg","alt":"","role":"img","aria-hidden":"true"}}),_c('label',[_vm._v(_vm._s(_vm.$t('fastForward')))])])
}
var staticRenderFns = []

export { render, staticRenderFns }